export enum ENUM__image_transform {
  NONE = 'none',
  COVER = 'cover', //crop_resize: keep AR, fit outside target, crop
  CONTAIN = 'contain', // fill_resize: keep AR, fit inside target, pad
  FILL = 'fill', //just_resize_simple: ignore AR, direct resize
  FILL_HEURISTIC = 'fill_heuristic', //just_resize: keep AR, heuristic resize
}

export namespace ENUM_UTILS__image_transform {
  export function get_all_except_none(): ENUM__image_transform[] {
    let out = Object.values(ENUM__image_transform).filter(item => item != ENUM__image_transform.NONE);

    return out;
  }

  export function to_css(value: ENUM__image_transform) {
    let out_map = new Map<ENUM__image_transform, string>([
      [ENUM__image_transform.CONTAIN, 'object-contain'],
      [ENUM__image_transform.COVER, 'object-cover'],
      [ENUM__image_transform.FILL, 'object-fill'],
      [ENUM__image_transform.NONE, 'object-none'],
    ]);

    let out = out_map.get_or_assert(value);

    return out;
  }
}
